import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMeta from '../components/SEOMeta';

const faqs = [
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major credit/debit cards (Visa, Mastercard) and M-Pesa for local payments. All transactions are secured with SSL encryption. We never store your card details.',
  },
  {
    q: 'How long does delivery take?',
    a: 'Delivery within Nairobi typically takes 1–2 business days. Orders to other counties take 2–4 business days depending on your location.',
  },
  {
    q: 'Do you offer free delivery?',
    a: 'Yes! Orders above KES 5,000 qualify for free delivery within the Nairobi region. A flat delivery fee applies to smaller orders.',
  },
  {
    q: 'Can I return a product?',
    a: 'We offer a 30-day return policy on all products. Items must be unused and in original condition with packaging intact. Contact us via WhatsApp on +254 724 474097 or email info@herclesglobal.com to initiate a return.',
  },
  {
    q: 'Are all products genuine?',
    a: 'Absolutely. We source all products from certified distributors and authorised importers. Every product carries manufacturer warranty where applicable.',
  },
  {
    q: 'How do I track my order?',
    a: 'Once your order is confirmed and payment processed, our team will contact you via phone or WhatsApp to coordinate delivery and provide real-time updates.',
  },
  {
    q: 'Is my payment information safe?',
    a: 'Yes. Our checkout is protected with 256-bit SSL encryption. M-Pesa payments are processed directly through the Safaricom network. We do not store your card or M-Pesa PIN.',
  },
];

function AboutPage() {
  const [openFaq, setOpenFaq] = useState(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <div className="about-page">
      <SEOMeta
        title="About Us"
        description="Learn about Hercles Global — Kenya's trusted electronics retailer in Nairobi. Find our shipping policy, returns, payment options M-Pesa/card, and FAQs."
        canonical="/about"
        jsonLd={faqJsonLd}
      />
      <Header />
      <div className="about-inner">

        <div className="about-hero">
          <h1>About Hercles Global</h1>
          <p>Your trusted technology partner in Kenya. We bring you the latest gadgets, electronics, and accessories at competitive prices — with a focus on quality, value, and customer satisfaction.</p>
        </div>

        <div className="about-section">
          <h2>Who We Are</h2>
          <p>Hercles Global is a Nairobi-based electronics retailer serving customers across Kenya. Founded with a vision to make quality tech accessible to everyone, we carry a curated range of smartphones, laptops, audio equipment, gaming accessories, and much more.</p>
          <p>Our team is passionate about technology and committed to helping you find exactly what you need — at the right price, every time.</p>
        </div>

        <div className="about-section">
          <h2>Shipping &amp; Delivery</h2>
          <ul>
            <li>📦 Nairobi CBD &amp; environs: <strong>1–2 business days</strong></li>
            <li>🚚 Countrywide delivery: <strong>2–4 business days</strong></li>
            <li>✓ Free delivery on orders over <strong>KES 5,000</strong> (Nairobi region)</li>
            <li>📞 Our team will call/WhatsApp you after ordering to confirm delivery details</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Returns &amp; Warranty</h2>
          <ul>
            <li>30-day return window (original condition and packaging required)</li>
            <li>All products carry manufacturer warranty where applicable</li>
            <li>Defective items replaced or refunded within 7 days of reporting</li>
            <li>Contact: WhatsApp +254 724 474097 or info@herclesglobal.com</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Secure Payments</h2>
          <p>We accept Visa, Mastercard, and M-Pesa. All online transactions are protected with 256-bit SSL encryption. Your payment information is never stored on our servers.</p>
        </div>

        <div className="about-section">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item">
              <button className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{faq.q}</span>
                <span className="faq-chevron">{openFaq === i ? '▲' : '▼'}</span>
              </button>
              {openFaq === i && <div className="faq-answer">{faq.a}</div>}
            </div>
          ))}
        </div>

        <div className="about-section about-contact">
          <h2>Contact Us</h2>
          <p>📍 Nairobi, Kenya</p>
          <p>📞 <a href="tel:+254724474097">+254 724 474097</a></p>
          <p>✉️ <a href="mailto:info@herclesglobal.com">info@herclesglobal.com</a></p>
          <p>🕐 Mon – Sat: 8 AM – 8 PM</p>
        </div>

      </div>
      <Footer />
    </div>
  );
}

export default AboutPage;
